import initialState from '../initialState';

const reducers = {
  LOAD_SUBMISSION_SUCCESS: (state, payload) => {
    return [
      ...state.filter(submission => submission.id !== payload.id),
      Object.assign({}, payload)
    ];
  },
  SUBMISSION_CREATED_SUCCESS: function(state, payload) {
    return [
      ...state.filter(submission => submission.id !== payload.id),
      Object.assign({},payload)
    ];
  }
};

export default function submissions(state = initialState.submissions, action) {
  let reducer = reducers[action.type];
  return (reducer ? reducer(state, action.submissions) : state);
}




/** WEBPACK FOOTER **
 ** ./src/reducers/submissions/submissionReducer.js
 **/